// extracted by mini-css-extract-plugin
export var carouselContainer = "carousel-module--carouselContainer--98622";
export var contentPanel = "carousel-module--contentPanel--c72d5";
export var controls = "carousel-module--controls--0617e";
export var ctaContainer = "carousel-module--ctaContainer--e9f0e related-products-module--ctaContainer--61c6d";
export var next = "carousel-module--next--0a308";
export var prev = "carousel-module--prev--adf55";
export var product = "carousel-module--product--279e8";